import { io, type Socket } from "socket.io-client";

// const env = process.env.NEXT_PUBLIC_NODE_ENV;

const CHAT_SOCKET_URL =
  import.meta.env.VITE_NODE_ENV === "development"
    ? import.meta.env.VITE_API_CHAT_SOCKET_URL_DEV
    : import.meta.env.VITE_NODE_ENV === "stage"
      ? import.meta.env.VITE_API_CHAT_SOCKET_URL_STAGE
      : import.meta.env.VITE_API_CHAT_SOCKET_URL_PROD;

export type ChatSocketAuth = {
  token: string;
  userId: string;
};

let chatSocket: Socket | null = null;
let lastAuthKey: string | null = null;

export function getChatSocket(): Socket | null {
  return chatSocket;
}

export function connectChatSocket(auth: ChatSocketAuth): Socket {
  const authKey = `${auth.userId}:${auth.token}`;

  if (!CHAT_SOCKET_URL) {
    throw new Error("CHAT_SOCKET_URL is not configured");
  }

  if (chatSocket && lastAuthKey === authKey) {
    if (!chatSocket.connected) chatSocket.connect();
    return chatSocket;
  }

  if (chatSocket) {
    try {
      chatSocket.disconnect();
    } catch {
      // ignore
    }
  }

  chatSocket = io(CHAT_SOCKET_URL, {
    transports: ["websocket"],
    autoConnect: false,
    reconnection: true,
    reconnectionAttempts: 10,
    withCredentials: true,
    auth: { token: auth.token },
    query: { userId: auth.userId },
  });

  lastAuthKey = authKey;
  chatSocket.connect();
  return chatSocket;
}

export function disconnectChatSocket() {
  if (!chatSocket) return;
  try {
    chatSocket.disconnect();
  } finally {
    chatSocket = null;
    lastAuthKey = null;
  }
}

export function joinChatRoom(roomId: string) {
  if (!chatSocket) return;
  chatSocket.emit("joinRoom", roomId);
}

export function sendTypingStatus(roomId: string, isTyping: boolean) {
  if (!chatSocket) return;
  chatSocket.emit("typing", { roomId, isTyping });
}

export function emitMessageRead(roomId: string, messageId: string) {
  if (!chatSocket) return;
  chatSocket.emit("messageRead", { roomId, messageId });
}
